module.exports = __webpack_public_path__ + "img/procreate-mobile_cn.13b1dc3.jpg";